const fmt = (v) => (typeof v === "number" ? v.toLocaleString("en-IN") : v ?? "—");

const CtSchoolsModalFilterToolbar = ({
  blockFilter,
  setBlockFilter,
  schoolFilter,
  setSchoolFilter,
  blockOptions,
  schoolOptions,
  loading,
  filteredCount,
  totalCount,
  countSuffix = null,
  onFilterChange,
}) => (
  <div className="usm-risk-modal-toolbar usm-risk-modal-toolbar-filters">
    <label className="usm-risk-modal-filter">
      <span>Block</span>
      <select
        value={blockFilter}
        onChange={(e) => {
          setBlockFilter(e.target.value);
          setSchoolFilter("");
          onFilterChange?.();
        }}
        disabled={loading || !blockOptions.length}
      >
        <option value="">All blocks</option>
        {blockOptions.map((block) => (
          <option key={block} value={block}>
            {block}
          </option>
        ))}
      </select>
    </label>
    <label className="usm-risk-modal-filter">
      <span>School</span>
      <select
        value={schoolFilter}
        onChange={(e) => {
          setSchoolFilter(e.target.value);
          onFilterChange?.();
        }}
        disabled={loading || !schoolOptions.length}
      >
        <option value="">All schools</option>
        {schoolOptions.map((school) => (
          <option key={school} value={school}>
            {school}
          </option>
        ))}
      </select>
    </label>
    {typeof totalCount === "number" ? (
      <span className="usm-risk-modal-count">
        Showing {fmt(filteredCount)} of {fmt(totalCount)} schools
        {countSuffix}
      </span>
    ) : null}
  </div>
);

export default CtSchoolsModalFilterToolbar;
